import { Component } from '@angular/core';
import {
  PhoenixButtonModule,
  PhoenixMenuButtonModule,
} from '@kehe/phoenix-button';
import { PhoenixManageListPageLayoutsModule } from '@kehe/phoenix-layouts';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { GridModule } from '@progress/kendo-angular-grid';
import { TransactionTypeGridComponent } from '../../components/transaction-type-grid/transaction-type-grid.component';
import { AddTransactionTypeModalComponent } from '../../components/add-transaction-type-modal/add-transaction-type-modal.component';
import { PhoenixModalModule } from '@kehe/phoenix-modal';

@Component({
  selector: 'app-transaction-type-list-page',
  imports: [
    PhoenixManageListPageLayoutsModule,
    GridModule,
    ButtonsModule,
    PhoenixModalModule,
    PhoenixButtonModule,
    TransactionTypeGridComponent,
    PhoenixMenuButtonModule,
    AddTransactionTypeModalComponent,
  ],
  templateUrl: './transaction-type-list-page.html',
  styleUrl: './transaction-type-list-page.scss',
})
export class TransactionTypeListPage {
  showAddTransactionTypeModal = false;

  openAddTransactionTypeModal() {
    this.showAddTransactionTypeModal = true;
  }

  closeAddTransactionTypeModal() {
    this.showAddTransactionTypeModal = false;
  }
}
